const AppInfoRow = ({ label, value, valueClass, labelClass, onClick, className }) => (
  <div className={`htInfoRow ${className}`} onClick={onClick}>
    <span className={`htIrLabel ${labelClass}`}>{label}</span>
    <span className={`htIrValue ${valueClass}`}>{value}</span>
  </div>
);
export default AppInfoRow;
